module.exports = __webpack_public_path__ + "57e02098cfc208d3e4cadcce45249a53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/banners/minzdrav_ru.jpg
// module id = 269
// module chunks = 0